import React, { FC } from 'react';
import { Column } from '.';
import { getFilterColor } from '../../helpers/colors';
import { FilledMapPin } from '../../icons';

// Centering happens on the cell itself (see `filterIndicatorCellStyle`), so this
// container just needs to hold the icon and carry the filter color.
const cellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

// AG Grid wraps every cell's content in a (non-full-height) `.ag-cell-wrapper`
// because the grid has `enableCellTextSelection` on. That wrapper collapses a
// renderer's `height: 100%`, so vertical centering has to be applied to the cell
// itself (which is always full-height) via the column's `cellStyle`.
export const filterIndicatorCellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

interface FilterIndicatorProps {
  colDef: Column<Entity>;
  data: Entity;
  value: number;
  stepColors?: string[];
}

const FilterIndicator: FC<FilterIndicatorProps> = ({
  data: rowData,
  value,
  stepColors,
  colDef: { onClick },
}) => {
  return (
    <div
      style={{
        ...cellStyle,
        color: getFilterColor(value, stepColors?.[value]),
        padding: 0,
      }}
      onClick={(e) => {
        if (onClick) {
          onClick(rowData);
          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      <FilledMapPin />
    </div>
  );
};

export default FilterIndicator;
